module.exports = __webpack_public_path__ + "img/DE02803.0e87fe4d.png";